module.exports = __webpack_public_path__ + "static/HeadzupSport_logo-51bc0dac7698b5f4811a6da52ab0b8af.png";